/** Mock del centro de ayuda; después se sincroniza con Soporte Wembii. */
export interface WembiiSupportArticleMock {
  id: string;
  title: string;
  snippet: string;
}

export const WEMBII_SUPPORT_ARTICLES_MOCK: WembiiSupportArticleMock[] = [
  {
    id: "ml cuenta",
    title: "Cómo crear una cuenta en Mercado Libre",
    snippet:
      "Sigue estas instrucciones y verás lo fácil que es. Foto ML ¿Cómo abrir una cuenta en Mercado Libre? Ingresá y completá tus datos paso a paso…",
  },
  {
    id: "ig empresa",
    title: "Cómo cambiar una cuenta de Instagram a Empresa ?",
    snippet:
      "Como ya sabemos Instagram cuando está con el Perfil Personal no puede hacer seguimiento de estadísticas avanzadas. Te mostramos cómo pasarlo a empresa…",
  },
  {
    id: "notif chat app",
    title: "Cómo activar notificaciones de Chat 💬 en la App 📱 ?",
    snippet:
      "Para activar las notificaciones de tu APP tienes que seguir los siguientes pasos: Ios (Iphone) 📱 Primero has de revisar los ajustes del sistema…",
  },
  {
    id: "ig mensajeria",
    title: "Admitir mensajería desde la APP de Instagram",
    snippet:
      "Hola Wembinero ! En este articulo te enseñamos cómo admitir el intercambios de mensajes a través de la aplicación oficial y no perder ningún contacto…",
  },
  {
    id: "fb pagina",
    title: "¿Cómo crear una página en Facebook para mi negocio?",
    snippet:
      "Te guiamos desde cero: tipo de página, datos del negocio, imagen de perfil y cómo conectarla con tu estrategia en redes…",
  },
  {
    id: "woo producto",
    title: "Cómo agregar un nuevo producto en Woo Commerce",
    snippet:
      "Para subir los productos seguir los siguientes pasos: accedé al panel, productos, añadir nuevo, imágenes, precio y publicar…",
  },
];
